import React, { useEffect, useState } from "react";
import TopTitleBanner from "../component/TopTitleBanner";
import "../css/dashboard.css";
import "../css/setting.css";
import { useAuth } from "../contexts/AuthContext";
import { roles } from "../firebase.collection";
import {
  documentId,
  onSnapshot,
  query,
  where,
  collection,
} from "firebase/firestore";
import { db } from "../firebase";

import { useNavigate } from "react-router-dom";

export default function EmailTemplateContent() {
  const [, setAllRoles] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [isHovered, setIsHovered] = useState(false); // État pour détecter le survol

  const { currentUser } = useAuth();
  const navigate = useNavigate(); // Initialisation de useNavigate

  const userIdState = currentUser ? currentUser.uid : "";

  // useEffect(() => {
  //   if (currentUser?.email) {
  //     recordMetrics("Roles", "pageLoad", currentUser.email, "read", "bodhi");
  //   }
  // }, [currentUser.email]);

  useEffect(() => {
    const roleCollection = collection(db, "roles");
    const unsubscribe = onSnapshot(roleCollection, (querySnapshot) => {
      setAllRoles(
        querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      );
    });
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("No user id");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  function queryRole() {
    onSnapshot(
      query(roles, where(documentId(), "==", userIdState)),
      (querySnapshot) => {
        const doc = querySnapshot.docs[0];
        if (doc && doc.exists) {
          const role = doc.data().role;

          setUserRole(role);
        } else {
          console.log("No role for this user");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }
    );
  }

  const isSuperAdmin =
    userRole === "Super Admin" || userRole === "Clinical Director";

  const handleButtonClick = () => {
    navigate("/template-1"); // Remplacez par la route correcte
  };

  const buttonStyle = {
    backgroundColor: "#4b6b9f",
    color: "white",
    width: "15%",
    paddingLeft: "10px",
    paddingRight: "10px",
    textAlign: "center",
    borderRadius: "10px",
    paddingTop: "5px",
    paddingBottom: "5px",
    cursor: "pointer",
    transform: isHovered ? "scale(1.02)" : "scale(1)",
    transition: "transform 0.1s ease",
  };

  return (
    <div className="right-container-settings">
      {isSuperAdmin ? (
        <div className="admin-panel">
          <TopTitleBanner title={"Email Templates Management"} />

          <div className="profile-title-setting">
            <div className="grey-subtitle-2 ">
              As a Super Admin, you can modify the template email for differents
              notifications
            </div>

            <div
              onClick={handleButtonClick}
              style={buttonStyle}
              onMouseEnter={() => setIsHovered(true)} // Détecte l'entrée de la souris
              onMouseLeave={() => setIsHovered(false)}
            >
              "Moving to Incoming" Notifications
            </div>
          </div>
        </div>
      ) : (
        <div>
          <TopTitleBanner title={"Email Templates Management"} />
          <p style={{ marginLeft: "60px", color: "red", fontWeight: "bold " }}>
            --You don't have Super-admin credentials to access this page--
          </p>
        </div>
      )}
    </div>
  );
}
